<template>
  <div class="personnel-archives-view">
    <Header title="Archives du personnel" />
    
    <div class="personnel-content">
      <h4>📁 Gestion des archives</h4>
      
      <div class="content-placeholder">
        <div class="placeholder-icon">
          <span class="material-icons">archive</span>
        </div>
        <h3>Archives du personnel</h3>
        <p>Cette fonctionnalité est en cours de développement.</p>
        <p>Le module permettra de consulter et gérer les archives des dossiers du personnel.</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import Header from '@/components/Header.vue'

onMounted(() => {
  //console.log('PersonnelArchivesView mounted')
})
</script>

<style scoped>
.personnel-archives-view {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.personnel-content {
  flex: 1;
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

.personnel-content h4 {
  font-size: 1.3rem;
  color: #455a64;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e0e0e0;
}

.content-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  text-align: center;
  margin: 20px 0;
}

.placeholder-icon {
  background-color: rgba(25, 118, 210, 0.1);
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.placeholder-icon .material-icons {
  font-size: 40px;
  color: #1976D2;
}

.content-placeholder h3 {
  font-size: 1.5rem;
  color: #455a64;
  margin-bottom: 16px;
}

.content-placeholder p {
  color: #78909c;
  max-width: 500px;
  margin: 0 auto 8px;
  line-height: 1.5;
}
</style>
